import React, { useRef } from "react";
import { RiAttachment2 } from "react-icons/ri";
import { useNewton } from "../../store/NewtonContext";

export const AttachFiles = () => {
  const {
    attachedFiles,
    selectedLibraryVideo,
    setAttachedFiles,
    setSelectedLibraryVideo,
    setVideoFile,
    videoFile,
  } = useNewton();

  const fileInputRef = useRef(null);

  const handleFileChange = (e) => {
    const selected = Array.from(e.target.files ?? []);
    if (!selected.length) return;

    const next = selected.filter(
      (f) =>
        f.type === "application/json" ||
        f.type === "text/csv" ||
        f.name.toLowerCase().endsWith(".csv") ||
        f.type === ""
    );

    // Clear other selections when files are added
    if (next.length > 0) {
      setVideoFile(null);
      setSelectedLibraryVideo(null);
    }

    const merged = [
      ...attachedFiles,
      ...next.filter(
        (nf) =>
          !attachedFiles.some(
            (ef) =>
              ef.name === nf.name &&
              ef.size === nf.size &&
              ef.lastModified === nf.lastModified
          )
      ),
    ];
    setAttachedFiles(merged);

    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };

  const isDisabled = !!videoFile || !!selectedLibraryVideo;

  return (
    <>
      <input
        accept="application/json,.csv,text/csv"
        className="hidden"
        multiple
        onChange={handleFileChange}
        ref={fileInputRef}
        type="file"
      />

      <div className="relative">
        <RiAttachment2
          className={`size-6 text-white ${
            !isDisabled ? "cursor-pointer" : "cursor-not-allowed opacity-50"
          }`}
          onClick={() =>
            isDisabled ? undefined : fileInputRef.current?.click()
          }
          title={
            attachedFiles?.length
              ? `${attachedFiles?.length} file(s) attached`
              : "Attach CSV(s)"
          }
        />

        {attachedFiles?.length > 0 && (
          <div className="absolute top-0 -right-1 flex size-3 min-w-3 items-center justify-center rounded-full bg-white">
            <span className="text-grayTrue500 text-sm font-semibold">
              {attachedFiles?.length}
            </span>
          </div>
        )}
      </div>
    </>
  );
};
